import { BRAND } from "../../type/EnumBrand";
import { IBrand } from "../../type/IBrand";

export const mother: IBrand = {
  id: "mother-audio",
  name: BRAND.MOTHER,
  logo: "/logo/mother_logo.jpg",
  website: "https://www.mother-proaudio.com/",
  description: `
Founded by Saša Ristić who started Beebird a company dedicated to building custom projects which ranged from classic compressors, eqs, monitor controllers and full scaled Neve consoles.  
Inspired to go beyond just re-creating classic hardware, he now brings us new hardware with his own flavor through the Mother brand. 
Injecting his own design and flair to come up with hardware that not only sounds good but has a refreshing look amongst the current generation of outboard hardware.
  `,
  videos: ["https://www.youtube.com/embed/9yeMW9Yqmfc?si=RCn9zwkEfTHMDFZJ", "https://www.youtube.com/embed/UXPh6BuCo_M?si=XfeYP2fIU82ku2Kf"]
}